import { Link } from 'react-router-dom';
import './EmptyState.css';

export interface EmptyStateAction {
  label: string;
  onClick?: () => void;
  to?: string;                 // renders a <Link> (role=link) when set
  variant?: 'primary' | 'secondary' | 'outline-primary';
  iconClass?: string;          // e.g. 'bi bi-upload me-2'
}

interface EmptyStateProps {
  icon: string;                // FULL icon class, e.g. 'bi bi-file-earmark-text' (same convention as action.iconClass)
  iconColor?: 'blue' | 'red' | 'muted';
  title?: string;              // omitted for inline variant if desired
  message?: string;
  actions?: EmptyStateAction[];
  size?: 'page' | 'inline';
  className?: string;
}

export function EmptyState({
  icon, iconColor = 'blue', title, message, actions = [], size = 'page', className,
}: EmptyStateProps) {
  return (
    <div className={`empty-state empty-state--${size} empty-state--${iconColor}${className ? ` ${className}` : ''}`}>
      <i className={`${icon} empty-state__icon`} aria-hidden="true"></i>
      {title && <h3 className="empty-state__title">{title}</h3>}
      {message && <p className="empty-state__message">{message}</p>}
      {actions.length > 0 && (
        <div className="empty-state__actions">
          {actions.map((a, i) =>
            a.to ? (
              <Link key={i} to={a.to} className={`btn btn-${a.variant ?? 'primary'}`}>
                {a.iconClass && <i className={a.iconClass}></i>}
                {a.label}
              </Link>
            ) : (
              <button key={i} className={`btn btn-${a.variant ?? 'primary'}`} onClick={a.onClick}>
                {a.iconClass && <i className={a.iconClass}></i>}
                {a.label}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
}
